class MegaMenu extends HTMLElement {
  currentClass = 'megamenu--current';
  visibleClass = 'megamenu--isVisible';
  animateClass = 'megamenu--animate';
  animateOutClass = 'megamenu--animateOut';
  noAnimationClass = 'megamenu--noAnimation';
  bodyClass = 'megamenu--isActive';
  menuElementClass = '[id^="shopify-section-sections"] #megamenu';
  mainNavTarget = 'header .header__menu-item.megamenu-item';
  curtainTarget = 'mega-menu-curtain';
  menuElement = null;
  timer = null;
  menuLinkHoverDuration = 100;
  listenersAdded = false;

  constructor() {
    super();

    this.onClickCurtain = this.onClickCurtain.bind(this);
    this.onMouseoverCurtain = this.onMouseoverCurtain.bind(this);
    this.onScrollWindow = this.onScrollWindow.bind(this);
    this.onMouseoverLink = this.onMouseoverLink.bind(this);
    this.onMouseoutLink = this.onMouseoutLink.bind(this);
    this.onResizeWindow = this.onResizeWindow.bind(this);

    this.initEventListeners();
    window.addEventListener('resize', this.onResizeWindow);
  }

  initEventListeners() {
    if (window.innerWidth >= 750 && !this.listenersAdded) {
      document.addEventListener('click', this.onClickCurtain);
      document.addEventListener('mouseover', this.onMouseoverCurtain);
      window.addEventListener('scroll', this.onScrollWindow);
      document.addEventListener('mouseover', this.onMouseoverLink);
      document.addEventListener('mouseout', this.onMouseoutLink);
      this.listenersAdded = true;
    } else if (window.innerWidth < 750 && this.listenersAdded) {
      this.removeEventListeners();
    }
  }

  removeEventListeners() {
    document.removeEventListener('click', this.onClickCurtain);
    document.removeEventListener('mouseover', this.onMouseoverCurtain);
    window.removeEventListener('scroll', this.onScrollWindow);
    document.removeEventListener('mouseover', this.onMouseoverLink);
    document.removeEventListener('mouseout', this.onMouseoutLink);
    this.listenersAdded = false;
  }

  onResizeWindow() {
    this.initEventListeners();
  }

  connectedCallback() {
    if (window.innerWidth >= 750) {
      this.menuElement = document.querySelector(this.menuElementClass);
      if (this.menuElement) {
        this.menuElement.style.display = 'initial';
        this.addCurtain();
      }
    }
  }

  addCurtain() {
    if (document.getElementById('megamenu')) {
      return;
    }

    this.innerHTML = '<mega-menu-curtain></mega-menu-curtain>' + this.innerHTML;
  }

  removeAnimation() {
    this.menuElement.classList.remove(this.animateClass);
    document.body.classList.remove(this.bodyClass);

    setTimeout(() => {
      this.menuElement.classList.remove(this.animateOutClass);
    }, 350);
  }

  showMenuItem(menuItemElement) {
    if (!menuItemElement) {
      return;
    }

    let menuId = "megamenu-" + menuItemElement.dataset.title;
    let menuItem = document.getElementById(menuId);

    if (!menuItem) {
      if (this.menuIsVisible()) {
        this.menuElement.classList.add(this.animateOutClass);
      }
      this.menuElement.classList.remove(this.noAnimationClass);
      this.hideAllMenuItems();
      this.removeAnimation();
      clearTimeout(this.timer);
      return;
    }

    let timerHoverDuration = (this.menuIsVisible()) ? 0 : this.menuLinkHoverDuration;

    this.timer = setTimeout(() => {
      // prepare menu for animation
      document.body.classList.add(this.bodyClass);
      this.menuElement.classList.add(this.animateClass);

      // show menu item
      setTimeout(() => {
        this.hideAllMenuItems();
        menuItemElement.classList.add(this.currentClass);
        menuItem.classList.add(this.visibleClass);

        setTimeout(() => {
          this.menuElement.classList.add(this.noAnimationClass);
        }, 200);
      }, timerHoverDuration)
    }, timerHoverDuration);
  }

  hideAllMenuItems() {
    // hide menu item
    let currentItems = document.querySelectorAll('.' + this.currentClass);
    if (currentItems) {
      for (let i = 0; i < currentItems.length; i++) {
        let item = currentItems[i];
        item.classList.remove(this.currentClass);
      }
    };

    let visibleItems = document.querySelectorAll('.' + this.visibleClass);
    if (visibleItems) {
      for (let i = 0; i < visibleItems.length; i++) {
        let item = visibleItems[i];
        item.classList.remove(this.visibleClass);
      }
    };
  }

  menuIsVisible() {
    return (document.querySelector('#megamenu.megamenu--animate')) ? true : false;
  }

  onClickCurtain(e) {
    if (!e.target.closest(this.curtainTarget)) {
      return false;
    }

    this.menuElement.classList.remove(this.noAnimationClass);
    this.hideAllMenuItems();
    this.removeAnimation();
  }

  onMouseoverCurtain(e) {
    if (!e.target.closest(this.curtainTarget)) {
      return false;
    }
    if (!this.menuIsVisible()) {
      return;
    }

    this.menuElement.classList.remove(this.noAnimationClass);
    clearTimeout(this.timer);
    this.hideAllMenuItems();
    this.removeAnimation();
  }

  onScrollWindow() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.menuElement.classList.remove(this.noAnimationClass);
      this.hideAllMenuItems();
      this.removeAnimation();
    }, 10); // Adjust the delay as needed
  }

  onMouseoverLink(e) {
    if (!e.target.closest(this.mainNavTarget)) {
      return false;
    }
    this.showMenuItem(e.target);
  }

  onMouseoutLink() {
    clearTimeout(this.timer);
  }
};

window.customElements.define("mega-menu", MegaMenu);

window.customElements.define("mega-menu-button", class Megamenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('mouseover', e => {
        e.target.closest('mega-menu-item').querySelectorAll('mega-menu-columns').forEach(column => column.style.display = 'none');
        e.target.closest('mega-menu-item').querySelectorAll('mega-menu-button').forEach(button => button.classList.remove('active'));
        let element = document.querySelector(`[data-type="${this.dataset.trigger}"]`);
        if (element) {
          element.style.display = '';
        }
        this.classList.add('active');
      });

      this.addEventListener('click', e => {
        if (this.dataset.href) {
          window.location.href = this.dataset.href;
        }
      });
    }
})
